// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqBarbelSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqBarbelSvg(props: Props) {
  const {fill, width = 16, height = 16} = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
      <path
        d="M19.9134 5.49994L23.4134 1.99994L21.9994 0.585938L18.4994 4.08594L15.7064 1.29294C15.5178 1.11078 15.2652 1.00999 15.003 1.01226C14.7408 1.01454 14.49 1.11971 14.3046 1.30512C14.1192 1.49053 14.014 1.74134 14.0118 2.00354C14.0095 2.26573 14.1103 2.51834 14.2924 2.70694L21.2924 9.70694C21.481 9.8891 21.7336 9.98989 21.9958 9.98761C22.258 9.98533 22.5088 9.88016 22.6942 9.69476C22.8797 9.50935 22.9848 9.25853 22.9871 8.99634C22.9894 8.73414 22.8886 8.48154 22.7064 8.29294L19.9134 5.49994ZM15.9997 6.58629L6.58594 16L8.00015 17.4142L17.4139 8.0005L15.9997 6.58629ZM2.00354 14.0122C2.26573 14.01 2.51834 14.1108 2.70694 14.2929L9.70694 21.2929C9.8891 21.4815 9.98989 21.7341 9.98761 21.9963C9.98533 22.2585 9.88016 22.5093 9.69476 22.6947C9.50935 22.8801 9.25853 22.9853 8.99634 22.9876C8.73414 22.9899 8.48154 22.8891 8.29294 22.7069L5.49994 19.9139L1.99994 23.4139L0.585938 21.9999L4.08594 18.4999L1.29294 15.7069C1.11078 15.5183 1.00999 15.2657 1.01226 15.0035C1.01454 14.7413 1.11971 14.4905 1.30512 14.3051C1.49053 14.1197 1.74134 14.0145 2.00354 14.0122Z"
        fill={fill}
      />
    </svg>
  );
}

export default EqBarbelSvg;
